<template>
  <v-btn
    data-testid="topBar-button-reportList"
    data-tourid="topBar-button-reportList"
    elevation="0"
    fab
    small
    :color="$vuetify.breakpoint.mobile ? 'white' : 'transparent'"
    @click="$emit('showReportsDrawer')"
  >
    <v-icon color="blue-grey darken-3">mdi-download-circle-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'ReportsDrawerTrigger',
}
</script>
